import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { MDatePicker, ResponsiveFormContainer } from "@app/components";
import dayjs from "dayjs";

interface Anexo3FormProps {
  mode: MODES_OPTIONS;
  disabled?: boolean;
}

const Anexo3Form = ({ mode, disabled }: Anexo3FormProps) => {
  const { watch, getValues } = useFormContext();
  const isView = mode === MODES_OPTIONS.VIEW;

  const [maxDate, setMaxDate] = useState<Date | undefined>(undefined);
  const [minDate, setMinDate] = useState<Date | undefined>(undefined);

  const evo_start_date = getValues("evo_start_date");
  const evo_end_date = getValues("evo_end_date");
  const year_pickup = watch("year_pickup");
  const start_week_pickup = watch("start_week_pickup");
  const end_week_pickup = watch("end_week_pickup");

  useEffect(() => {
    if (evo_start_date) {
      const minDateObj = dayjs(evo_start_date).toDate();

      setMinDate(minDateObj);
    }

    if (evo_end_date) {
      const maxDateObj = dayjs(evo_end_date).toDate();
      setMaxDate(maxDateObj);
    }
  }, [evo_start_date, evo_end_date]);

  useEffect(() => {
    if (year_pickup && start_week_pickup) {
      const startDate = dayjs()
        .year(year_pickup)
        .isoWeek(start_week_pickup)
        .startOf("isoWeek")
        .toDate();
      setMinDate(startDate);
    }

    if (year_pickup && end_week_pickup) {
      const endDate = dayjs()
        .year(year_pickup)
        .isoWeek(end_week_pickup)
        .endOf("isoWeek")
        .toDate();
      setMaxDate(endDate);
    }
  }, [year_pickup, start_week_pickup, end_week_pickup]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Anexo III"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5}>
        <MDatePicker
          name="start_date_origin_year"
          pickerType="date"
          label="Fecha inicio a origen año"
          validation={{
            required: "La fecha de inicio a origen año es requerida",
          }}
          disabled={isView || disabled}
        />
        <MDatePicker
          name="end_date_origin_year"
          pickerType="date"
          label="Fecha límite"
          validation={{
            required: "Fecha límite es requerida",
          }}
          disabled={isView || disabled}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Anexo3Form;
